import Axios from "../../../../../api/axios/Axios";

const enc = (value) => encodeURIComponent(String(value ?? "").trim());

const base = (groupTag) => `/api/groups/${enc(groupTag)}/videos`;

export const getMemberGroupVideoThumbs = (
  groupTag,
  limit = 12,
  offset = 0,
  signal,
) =>
  Axios.get(base(groupTag), {
    params: { limit, offset },
    signal,
  });

export const getMemberGroupVideoPlay = (groupTag, videoTag, signal) =>
  Axios.get(`${base(groupTag)}/${enc(videoTag)}/play`, {
    signal,
  });
